import React, { PureComponent } from "react";

import firebase from "firebase";

import { Row, Col, Input, Form, InputNumber, Button, Space } from "antd";

import axios from "axios";
import swal from "sweetalert";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import ApiGeneral from "../../app/generalApi";

const apiGeneral = new ApiGeneral();

import "antd/dist/antd.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import moment from "moment";
moment.locale("es");

const BASE_URL = "https://us-central1-escuelapp-5f754.cloudfunctions.net/";

const isMobile = window.innerWidth <= 500;

class NewSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      waiting: false,
      userData: {},
      logged: false,
      selectedSubscription: apiGeneral.testing()
        ? "price_1N6rs5FaAT8NSpmElBTD2gTt"
        : "price_1N7DwpFaAT8NSpmEJ6eVEsRt",
      successCode: "",
      selectedCode: null,
      selectedDays: 7,
      asistents: 1,
      asistentsData: [""],
      errorCode: "",
      stripeCustomerId: null,
      isPlanAmigo: false,
      friend: {},
      countries: [],
      selectedCountry: "Spain",
      loadingCreating: false,
      price: 390,
    };

    this.formRef = React.createRef();
    this.checkLogin = this.checkLogin.bind(this);
    this.setFormData = this.setFormData.bind(this);
    this.setFormDataPersonal = this.setFormDataPersonal.bind(this);
    this.processPayment = this.processPayment.bind(this);
    this.updateStripeID = this.updateStripeID.bind(this);
    this.goToCheckOut = this.goToCheckOut.bind(this);
    this.customerPortal = this.customerPortal.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.getRegisterForm = this.getRegisterForm.bind(this);
  }

  componentDidMount() {}

  checkLogin() {
    //IS LOGGED?
    var user = firebase.auth().currentUser;

    if (user) {
      return user;
    } else {
      return null;
    }
  }

  onChange = (e) => {
    //console.log("radio checked", e.target.value);
    this.setState({
      selectedSubscription: e.target.value,
    });
  };

  onChangeAsistents = (e) => {
    console.log("radio checked", e);
    var finalAsistents = [];

    for (var i = 0; i < e; i++) {
      finalAsistents.push("");
    }

    var suscription = this.state.selectedSubscription;

    console.log(apiGeneral.testing());

    console.log("ASISTENTES", e);

    console.log("suscripcion", this.state.selectedSubscription);

    this.setState({
      asistents: e,
      asistentsData: finalAsistents,
      selectedSubscription: suscription,
    });

    console.log(finalAsistents);
  };

  onChangeAsistentsData = (e, index) => {
    console.log("radio checked", e.target.value, index);

    var asistents = this.state.asistentsData;
    asistents[index] = e.target.value;

    this.setState({
      asistentData: asistents,
    });

    console.log("ASISTENTES", this.state.asistentsData);
  };

  onChangeZone = (e) => {
    //console.log("radio checked", e.target.value);

    this.setState({
      selectedZone: e.target.value,
    });
  };

  setFormData(event) {
    //console.log(event.target.value);
    let value = event.target.value;

    let edited = this.state.userData;

    if (!edited.facturacion) {
      edited.facturacion = {};
    }

    edited["facturacion"][event.target.name] = value;
    this.setState({ userData: edited });
  }

  setFormDataPersonal(event) {
    //console.log(event.target.value);
    let value = event.target.value;

    let edited = this.state.userData;
    edited[event.target.name] = value;
    this.setState({ userData: edited });
  }

  async updateStripeID(customerId) {
    const userData = this.state.userData;

    let user = {};

    user.stripeId = customerId;

    const result = await apiGeneral.updateStripeId(userData.uid, customerId);
  }

  getRegisterForm = () => {
    const { asistentsData } = this.state;

    return (
      <Row justify="center">
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 24, offset: 0 }}
          md={{ span: 24, offset: 0 }}
          lg={{ span: 24, offset: 0 }}
          xl={{ span: 12, offset: 0 }}
          xxl={{ span: 12, offset: 0 }}
          style={{ textAlign: "center" }}
        >
          <br></br>

          <div>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row justify="center">
                <div
                  style={{
                    color: "#ffffff",
                    backgroundColor: apiGeneral.getBackgroundColor(),
                    height: "40px",
                    width: "100%",
                    padding: "10px",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  DATOS DE LOS ASISTENTES
                </div>
              </Row>
              <Row>
                <Form.Item label="Número de plazas">
                  <InputNumber
                    min={1}
                    max={10}
                    onChange={this.onChangeAsistents}
                    value={this.state.asistents}
                  />
                </Form.Item>
                <br></br>
              </Row>
              <Form
                ref={this.formRef}
                layout={"vertical"}
                name="basic"
                style={{ width: "100%" }}
                size="large"
                onFinish={(values) => {
                  var isValid = true;

                  var asistents = this.state.asistentsData;

                  asistents.forEach((element) => {
                    if (!element) {
                      isValid = false;
                    }
                  });

                  if (!isValid) {
                    swal({
                      buttons: {
                        confirm: {
                          text: "ACEPTAR",
                          className: "blue-bg",
                          visible: true,
                        },
                      },
                      title: "Atención",
                      text: "Debes rellenar todos los nombres de los asistentes",
                      icon: "warning",
                    }).then((value) => {
                      //console.log(value);
                    });
                  } else {
                    this.setState({ loadingCreating: true });

                    this.processPayment(values);
                  }
                }}
              >
                {asistentsData.map((n, i) => {
                  return (
                    <Row>
                      <Form.Item
                        style={{ marginBottom: "5px", width: "100%" }}
                        rules={[
                          {
                            required: true,
                            message:
                              "Por favor, introduce el nombre completo del asistente",
                          },
                        ]}
                      >
                        <Input
                          name={`asistente${n}`}
                          onChange={(e) => this.onChangeAsistentsData(e, i)}
                          placeholder={`Nombre completo asistente ${i + 1}`}
                        />
                      </Form.Item>
                    </Row>
                  );
                })}
                <br></br>
                <Row justify="center">
                  <div
                    style={{
                      color: "#ffffff",
                      backgroundColor: apiGeneral.getBackgroundColor(),
                      height: "40px",
                      width: "100%",
                      padding: "10px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    DATOS DE FACTURACIÓN
                  </div>
                </Row>

                <br></br>
                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, introduce tu email",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message:
                        "Por favor, introduce el nombre completo el de la empresa",
                    },
                  ]}
                >
                  <Input placeholder="Nombre completo / Nombre de la empresa" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="es_cif"
                  rules={[
                    {
                      required: false,
                      message: "Por favor, introduce el DNI / CIF",
                    },
                  ]}
                >
                  <Input placeholder="DNI / CIF" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="line1"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, introduce la dirección",
                    },
                  ]}
                >
                  <Input placeholder="Dirección" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="line2"
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Input placeholder="Dirección línea 2" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="postal_code"
                  rules={[
                    {
                      required: false,
                      message: "Por favor, introduce el código postal",
                    },
                  ]}
                >
                  <Input placeholder="Código postal" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, introduce la provincia",
                    },
                  ]}
                >
                  <Input placeholder="Provincia / Estado" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, introduce la ciudad",
                    },
                  ]}
                >
                  <Input placeholder="Ciudad / Localidad" />
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "5px" }}
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, introduce el teléfono",
                    },
                  ]}
                >
                  <Input placeholder="Teléfono" />
                </Form.Item>

                <br></br>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className={apiGeneral.getButtonsStyle()}
                    disabled={this.state.loadingCreating}
                  >
                    {this.getButtonText()}
                  </Button>
                </Form.Item>
              </Form>
            </Space>
          </div>
        </Col>
      </Row>
    );
  };

  async processPayment(facturacion) {
    this.setState({ waiting: true });

    var finalData = {};
    finalData.address = {};
    finalData.address.line1 = facturacion.line1;
    finalData.address.line2 = facturacion.line2 || "";
    finalData.address.city = facturacion.city;
    finalData.address.country = facturacion.country;
    finalData.address.postal_code = facturacion.postal_code;
    finalData.address.state = facturacion.state;
    finalData.email = facturacion.email;
    finalData.name = facturacion.name;
    finalData.phone = facturacion.phone;

    finalData.tax_id_data = [{ type: "es_cif", value: facturacion.es_cif }];

    if (facturacion.es_cif) {
      finalData.address.line2 =
        (finalData.address.line2 || "") + (" CIF: " + facturacion.es_cif);
      finalData.shipping = {};
      finalData.shipping.name = "CIF";
      finalData.shipping.address = {};
      finalData.shipping.address.line2 = " CIF: " + facturacion.es_cif;
    }
    var resultUser = {};

    finalData.testing = apiGeneral.testing();

    resultUser = await axios.post(`${BASE_URL}createCustomer2`, finalData, {
      crossDomain: true,
    });

    console.log("CREATE CUSTOMER", resultUser);

    if (resultUser.data) {
      var dataCheckout = {};
      dataCheckout.email = facturacion.email;
      dataCheckout.customer = resultUser.data.id;
      dataCheckout.quantity = this.state.asistents;

      var metadata = {};

      var asistentData = this.state.asistentsData;

      for (var i = 0; i < asistentData.length; i++) {
        metadata[`Nombre del asistente ${i + 1}`] = asistentData[i];
      }
      dataCheckout.metadata = metadata;

      console.log(dataCheckout.metadata);
      //this.goToCheckOut(dataCheckout);

      this.goToCheckOut(dataCheckout, facturacion.postal_code);
    }
  }

  async goToCheckOut(data, postalCode) {
    if (data.quantity == 1) {
      if (apiGeneral.testing()) {
        data.selectedSubscription = "price_1N6rs5FaAT8NSpmElBTD2gTt";
      } else {
        data.selectedSubscription = "price_1N7DwpFaAT8NSpmEhidkJbXK";
      }
    } else if (data.quantity == 2) {
      if (apiGeneral.testing()) {
        data.selectedSubscription = "price_1N6rs4FaAT8NSpmEM1uCo53H";
      } else {
        data.selectedSubscription = "price_1N7DwpFaAT8NSpmEYFjMlHxN";
      }
    } else {
      if (apiGeneral.testing()) {
        data.selectedSubscription = "price_1N6rs4FaAT8NSpmEsofXejwz";
      } else {
        data.selectedSubscription = "price_1N7DwpFaAT8NSpmEJ6eVEsRt";
      }
    }

    if (apiGeneral.canaryZIP().includes(parseInt(postalCode))) {
      //data.iva = "";
      //console.log("BORRAMOS IVA");
      console.log("ES DE CANARIAS");
    } else {
      data.iva = apiGeneral.testing()
        ? "txr_1N6roLFaAT8NSpmERcb4HR81"
        : "txr_1Hc8oNFaAT8NSpmE6bfgQOaZ";
    }

    data.testing = apiGeneral.testing();

    const resultSession = await axios.post(
      `${BASE_URL}createPaymentCurso`,
      { data },
      { crossDomain: true }
    );

    console.log("SESSION", resultSession);
    if (resultSession) {
      const sessionId = resultSession.data.id;

      const testKey = "pk_test_AWIi7aMrX3qbdQpr57wsueei00a5vIzcXR";
      const productionKey = "pk_live_JqMlcV5hos6at5MY5SsvfAM200552ZQFUt";
      var stripe = Stripe(apiGeneral.testing() ? testKey : productionKey);

      const resultCheckOut = await stripe.redirectToCheckout({
        sessionId: sessionId,
      });

      if (resultCheckOut) {
        console.log("RESULTADO", result);
      }
    }
  }

  async onSearch(e) {
    var value = e.target.value;

    try {
      if (!value) {
        return;
      }

      var result = await apiGeneral.checkCode(value.trim());

      if (result) {
        var info = result[0];

        if (info.isVip === true || info.isVip === "true") {
          this.setState({
            successCode: "Código válido: " + info.descripcion,
            selectedCode: info,
            selectedDays: parseInt(info.duracion),
            errorCode: "",
          });
        } else {
          if (
            parseInt(info.stock) >= 1 &&
            (info.activo === true || info.activo === "true")
          ) {
            this.setState({
              successCode: "Código válido: " + info.descripcion,
              selectedCode: info,
              selectedDays: parseInt(info.duracion),
              errorCode: "",
            });
          } else {
            this.setState({
              selectedDays: 7,
              selectedCode: null,
              errorCode: "El código introducido no existe o ha caducado",
              successCode: "",
            });
          }
        }
      } else {
        this.setState({
          selectedDays: 7,
          selectedCode: null,
          errorCode: "El código introducido no existe o ha caducado",
          successCode: "",
        });
      }
    } catch (error) {
      alert(error);
    }
  }

  async customerPortal() {
    this.setState({ waiting: true });

    const _customers = await axios.get(
      `${apiGeneral.getApiUrl()}stripe/by-email/${this.state.userData.email}	`,
      { crossDomain: true }
    );

    var customers = _customers.data;

    const session = await axios.post(
      `${BASE_UR}stripe/createcustomerportal`,
      {
        customerId: customers.id,
        testing: apiGeneral.testing(),
      },
      { crossDomain: true }
    );

    if (session.data) {
      window.open(session.data.url, "_blank");
    }

    this.setState({ waiting: false });
  }

  onChangePhoto = async (event) => {
    this.setState({
      uploadingPoster: true,
      posterUploaded: false,
    });

    let selectedFile = event.target.files[0];

    let files = new Array();
    files.push(selectedFile);

    const result = await apiGeneral.uploadImagen(files);

    if (result) {
      this.setState({ poster: result });

      this.setState({
        uploadingPoster: false,
        posterUploaded: true,
      });
    } else {
      this.setState({
        uploadingPoster: false,
        posterUploaded: false,
      });
    }
  };

  getButtonText() {
    var price = this.state.price;

    if (this.state.asistents == 1) {
      price = 490;
    } else if (this.state.asistents == 2) {
      price = 450;
    } else {
      price = 390;
    }

    if (!this.state.waiting) {
      return `Proceder al Pre-Pago ${price * this.state.asistents}€ + IVA`;
    } else {
      return "UN MOMENTO POR FAVOR...";
    }
  }

  getContent() {
    const facturacion = this.state.userData.facturacion || {};
    const subscription = this.state.userData.subscription || {};

    const isVip = this.state.userData.isVip;
    const { isPlanAmigo, friend } = this.state;

    if (subscription) {
      //console.log("tu suscripcion actual es", subscription);
    }

    return (
      <div
        style={{
          marginBottom: "200px",

          padding: isMobile ? "10px" : "40px",
        }}
      >
        <Row></Row>
        <Row
          justify="center"
          style={{ marginBottom: "200px", marginTop: "50px" }}
        >
          <Col
            xs={{ span: 24, offset: 0 }}
            sm={{ span: 24, offset: 0 }}
            md={{ span: 24, offset: 0 }}
            lg={{ span: 24, offset: 0 }}
            xl={{ span: 24, offset: 0 }}
            xxl={{ span: 24, offset: 0 }}
            style={{ textAlign: "center" }}
          >
            <h1>Formulario de inscripción</h1>
            <p>Rellena el siguiente formulario para inscribirte en el curso</p>

            <div style={{ textAlign: "center" }}>{this.getRegisterForm()}</div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    return this.getContent();
  }
}

export default NewSubscription;



// WEBPACK FOOTER //
// ./components/PaymentCurse/index.js